import { DELETE_ANNOUNCEMENTS_LOADING, DELETE_ANNOUNCEMENTS_SUCCESS, DELETE_ANNOUNCEMENTS_ERROR } from "../../../constant/actionTypes";

const deleteAnnouncementReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_ANNOUNCEMENTS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case DELETE_ANNOUNCEMENTS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case DELETE_ANNOUNCEMENTS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default deleteAnnouncementReducer;